import { onMounted } from 'vue'

//设置组件初始值，需要保证组件渲染时在表单已经渲染完成后执行
export function useComponentDefault({ value, getData, type, setVal, disabled }) {
  onMounted(async () => {
    //当有值时不进行默认值赋值
    if (value !== undefined && value !== null) {
      return
    }
    //当选项只有一个值时默认赋值
    if (type === 'ONLY_ONE' && !disabled) {
      const [res] = await getData()
      if (res?.data?.length === 1) {
        setVal(res.data[0])
      }
    }
  })
}
